import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';

import { Modal, Paper, Button, LinearProgress, Animation } from 'components'

import * as actionCreators from 'store/actions'

const Container = styled.div`
    background-color: var(--secondary-color);
    display: grid;
    grid-template-rows: auto 1rem auto;
    align-items: center;
    grid-gap: 0.5rem;
    padding: 1rem;
    text-align: center;
    border-radius: 5px;
`

class LogoutDialogue extends Component {
    constructor(props){
        super(props);
        setTimeout(() => {
            this.signOutHandler()
        }, 3000)
    }

    signOutHandler = () => {
        this.props.signOutApp()
        this.props.setModal(null,null)
        this.props.setSecModal(null,null)
    }

    render() {
        return (
            <Modal>
                <Animation animation='expand'>
                    <Paper>
                        <Container>
                            {this.props.message}
                            <LinearProgress time='3'/>
                            <Button text='Logout' onSelect={() => this.signOutHandler} styles={{backgroundColor: 'var(--focus-color)', margin: 0}}/>
                        </Container>
                    </Paper>
                </Animation>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
        
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        setSecModal: (element, id) => dispatch(actionCreators.setSecModal(element,id)),
        signOutApp: () => dispatch(actionCreators.signOutApp()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutDialogue);